import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import {
    AccountLanguagesComponent
} from 'account-hybrid/common/modules/account-management/components/account-languages/account-languages.component';
import { IdentityService } from 'account-hybrid/core/authentication';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { CreatePropertyComponent } from './components/create-property/create-property.component';
import {
    ACCOUNT_MANAGEMENT_FEATURE_NAME,
    AccountLanguagesEffects,
    loadAccountLanguages,
    loadAvailableAccountLanguages,
    reducers
} from './store';
import { ManagementEffects } from './store/management/management.effects';
import { loadContextDetails } from 'account-hybrid/store';
import { AccountBootLoads } from './account-boot-loads';

@NgModule({
    declarations: [
        CreateAccountComponent,
        CreatePropertyComponent,
        AccountLanguagesComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    AccountSharedModule,
    EffectsModule.forFeature([ManagementEffects, AccountLanguagesEffects]),
    StoreModule.forFeature(ACCOUNT_MANAGEMENT_FEATURE_NAME, reducers),
    NgbTooltip
  ],
    exports: [
        CreateAccountComponent,
        CreatePropertyComponent,
        AccountLanguagesComponent
    ]
})
export class AccountManagementModule {
    constructor(private store: Store<any>, private identityService: IdentityService, private bootLoads: AccountBootLoads) {
        if (!this.identityService.isAnonymous()) {
            // Guarded because this module is constructed once per injector — the eager graph builds it
            // at bootstrap, and every lazy feature that pulls in SpacesModule builds it again. See
            // AccountBootLoads for why once-per-document is the correct scope.
            this.bootLoads.dispatchOnce(() => {
                this.store.dispatch(loadAvailableAccountLanguages());
                this.store.dispatch(loadAccountLanguages());
                this.store.dispatch(loadContextDetails());
            });
        }
    }
}
